import React from "react";

const SlashWrenchSVG: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      d="M14.438 13.625c-.508 0-.965-.076-1.397-.229L8.42 18.018c-.305.304-.762.482-1.219.482-.94 0-1.701-.762-1.701-1.701 0-.457.178-.914.482-1.219l4.622-4.621a4.133 4.133 0 0 1-.229-1.396A4.058 4.058 0 0 1 14.438 5.5c.38 0 .761.076 1.117.178.254.076.33.406.127.61l-1.955 1.954a.382.382 0 0 0-.102.28v1.447c0 .228.178.406.406.406h1.447a.382.382 0 0 0 .28-.102l1.955-1.955c.203-.203.533-.152.61.127.1.356.177.737.177 1.117a4.058 4.058 0 0 1-4.063 4.063ZM7.53 17.078c.33 0 .61-.254.61-.61 0-.33-.28-.609-.61-.609-.355 0-.61.28-.61.61 0 .355.255.61.61.61Z"
      fill="#A5AAB5"
    />
    <mask
      id="a"
      maskUnits="userSpaceOnUse"
      x="4.566"
      y="6.215"
      width="13.435"
      height="13.435"
      fill="#000"
    >
      <path fill="#fff" d="M4.566 6.215h13.435V19.65H4.566z" />
      <path d="M6.157 6.745a.75.75 0 0 1 1.06 0l10.254 10.253a.75.75 0 0 1-1.06 1.06L6.156 7.807a.75.75 0 0 1 0-1.06Z" />
    </mask>
    <path
      d="M6.157 6.745a.75.75 0 0 1 1.06 0l10.254 10.253a.75.75 0 0 1-1.06 1.06L6.156 7.807a.75.75 0 0 1 0-1.06Z"
      fill="#1D2948"
    />
    <path
      d="M6.688 6.215 18 17.529 6.687 6.215ZM17.47 18.059a2.25 2.25 0 0 1-3.182 0L6.157 9.927a2.25 2.25 0 0 1 0-3.182.75.75 0 0 1 1.06 0l-.53-.53 10.784 10.783a.75.75 0 0 1 0 1.06ZM5.627 7.275l1.06-1.06-1.06 1.06ZM18 17.53l-1.06 1.06L18 17.53Z"
      fill="#E5E8E9"
      mask="url(#a)"
    />
  </svg>
);

export default SlashWrenchSVG;
